//Any non-senstive storeconf variable should be added here to access it from settings.userData
//Do not add sensitive variables to this list
//Keep the list in Alphabatical order for readability
export const USERDATA_GENERIC_STORECONF_KEYS = [
    'authServerList',
    'APlusLegoVendor',
    'AllowStorePickForOOSItems',
    'bvSiteId',
    'bvEnvironment',
    'bvLocale',
    'bvClientName',
    'CartHRProductRecomBoxId',
    'ClickAndCollectStoreEndTimeCutOff',
    'ClickAndCollectShowStoresCount',
    'CountdownDateTimeValue',
    'CountdownBackgroundImage',
    'CountdownDestinationURL',
    'CountdownWidgetHeading',
    'DHLHolidayList',
    'DonateItemPartNumber',
    'DonateItemPartNumberThumbnail',
    'FlowBoxCheckoutScriptAPIKey',
    'FiguresURLMappings1',
    'FiguresURLMappings2',
    'FiguresURLMappings3',
    'FiguresURLMappings4',
    'FiguresURLMappings5',
    'google.tag.manager.container.id',
    'google.tag.manager.auth',
    'google.tag.manager.preview',
    'google.analytics.versions',
    'GiftCardsToExcludeAfterThreshold',
    'GroupOtherPaymentTypes',
    'GTMEnvironment',
    'HideProductAttributes',
    'headlessStore.storeContextRoot',
    'HelloretailSearchConfigKey',
    'HelloRetailSearchEnabled',
    'HelloRetailUUID',
    'HelloRetailPopularProductsBoxId',
    'HelloRetailRecommendationURL',
    'HelloretailCategoryLinkCount',
    'HelloretailProductCount',
    'HomePageTokenValue',
    'isWebpON',
    'Klarna_Environment',
    'Klarna_ExpressButtonEndPointURL',
    'Klarna_OnsiteMessagingEndPointURL',   
    'Locationiq_Service_URL',
    'Locationiq_Search_URL',
    'Locationiq_results_limit',
    'Locationiq_viewbox_coordinates',
    'Locationiq_tags_list',
    'LoyaltyPopupInfoShowDelay',
    'maxImagesRuby',
    'MyAccountHRProductRecomBoxId',
    'MyAccountAllowedUserAge',  
    'NewsLetterSubscriptionContactListId',  
    'orderActualFreeShippingMinimum',
    'orderActualCheckoutMinimum',
    'orderFreeShippingMinimum',
    'orderCheckoutMinimum',
    'ProductBrandAttributeName',
    'ProductBrandAttributeValue',
    'RibbonsDisplayCount',
    'RobotsExcludeFollowPages',
    'RobotsExcludeNoFollowPages',
    'RobotsExcludeFollowPages1',
    'RobotsExcludeFollowPages2',
    'RobotsExcludeFollowPages3',
    'RobotsExcludeFollowPages4',
    'SkipMaxOrderForB2BUser',
    'StoreStockStoreCountTODisplay',
    'StoreLocatorStoreStockPDP_MaxItems',
    'StorepickAllowedAttributeValue',
    'StorepickAllowedAttribute',
    'StoreLocator_RadiusUOM',
    'StoreLocator_Radius',
    'StorePickupMaxAllowedQuantity',
    'StaticHostSecure',
    'SiteLink_DomainName',   
    'StoreLocatorSpecialOpeningMaxCount',
    'Treazure_PromoEngine_Loyalty_AccountCheck_Enabled',
    'Treazure_PromoEngine_Loyalty_Account_Number_Length',
    'Treazure_PromoEngine_Loyalty_Account_Number_Regex',
    'UserPreferencesForNewsLetterSubscription',
    'VVV_GIFT_CARD_THRESHOLD',        
    'WebPImageOptimizedFolder',
    'UserInactivityTimeAlert'
]